"use strict";

var _regeneratorRuntime = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ensureFile = exports.removeFile = exports.updateContent = exports.readContent = exports.createContent = void 0;

var _path = _interopRequireDefault(require("path"));

var _ = require("../");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // POST /api/v1/repos/{owner}/{repo}/contents/{filepath}


var createContent = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var owner, repo, filepath, payload, config, url, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            owner = _ref.owner, repo = _ref.repo, filepath = _ref.filepath, payload = _ref.payload, config = _ref.config;
            url = _path.default.join(_.apiPath, 'repos', owner, repo, 'contents', filepath);
            _context.next = 4;
            return (0, _.post)({
              url: url,
              payload: payload,
              config: config
            });

          case 4:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function createContent(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.createContent = createContent; // GET /api/v1/repos/{owner}/{repo}/contents/{filepath}?ref={branch}

var readContent = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var owner, repo, filepath, config, url, response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            owner = _ref3.owner, repo = _ref3.repo, filepath = _ref3.filepath, config = _ref3.config;
            url = _path.default.join(_.apiPath, 'repos', owner, repo, 'contents', filepath);
            _context2.prev = 2;
            _context2.next = 5;
            return (0, _.get)({
              url: url,
              config: config,
              noCache: true
            });

          case 5:
            response = _context2.sent;
            _context2.next = 11;
            break;

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](2);
            response = null;

          case 11:
            return _context2.abrupt("return", response);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 8]]);
  }));

  return function readContent(_x2) {
    return _ref4.apply(this, arguments);
  };
}(); // PUT /api/v1/repos/{owner}/{repo}/contents/{filepath}


exports.readContent = readContent;

var updateContent = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
    var owner, repo, filepath, payload, config, url, response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            owner = _ref5.owner, repo = _ref5.repo, filepath = _ref5.filepath, payload = _ref5.payload, config = _ref5.config;
            url = _path.default.join(_.apiPath, 'repos', owner, repo, 'contents', filepath);
            _context3.prev = 2;
            _context3.next = 5;
            return (0, _.put)({
              url: url,
              payload: payload,
              config: config
            });

          case 5:
            response = _context3.sent;
            _context3.next = 11;
            break;

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](2);
            response = null;

          case 11:
            return _context3.abrupt("return", response);

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[2, 8]]);
  }));

  return function updateContent(_x3) {
    return _ref6.apply(this, arguments);
  };
}(); // DELETE /api/v1/repos/{owner}/{repo}/contents/{filepath}?ref={branch}


exports.updateContent = updateContent;

var removeFile = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref7) {
    var owner, repo, filepath, payload, config, url, response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            owner = _ref7.owner, repo = _ref7.repo, filepath = _ref7.filepath, payload = _ref7.payload, config = _ref7.config;
            url = _path.default.join(_.apiPath, 'repos', owner, repo, 'contents', filepath);
            _context4.prev = 2;
            _context4.next = 5;
            return (0, _.del)({
              url: url,
              payload: payload,
              config: config
            });

          case 5:
            response = _context4.sent;
            _context4.next = 11;
            break;

          case 8:
            _context4.prev = 8;
            _context4.t0 = _context4["catch"](2);
            response = null;

          case 11:
            return _context4.abrupt("return", response);

          case 12:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[2, 8]]);
  }));

  return function removeFile(_x4) {
    return _ref8.apply(this, arguments);
  };
}();

exports.removeFile = removeFile;

var ensureFile = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref9) {
    var owner, repo, filepath, payload, config, file, _yield$createContent, content;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            owner = _ref9.owner, repo = _ref9.repo, filepath = _ref9.filepath, payload = _ref9.payload, config = _ref9.config;
            _context5.next = 3;
            return readContent({
              owner: owner,
              repo: repo,
              filepath: filepath,
              config: config
            });

          case 3:
            file = _context5.sent;

            if (file) {
              _context5.next = 10;
              break;
            }

            _context5.next = 7;
            return createContent({
              owner: owner,
              repo: repo,
              filepath: filepath,
              payload: payload,
              config: config
            });

          case 7:
            _yield$createContent = _context5.sent;
            content = _yield$createContent.content;
            file = content;

          case 10:
            return _context5.abrupt("return", file);

          case 11:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function ensureFile(_x5) {
    return _ref10.apply(this, arguments);
  };
}();

exports.ensureFile = ensureFile;